import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./admin/AdminSidebar";

// Menu dashboard Admin utama. Tampilan sidebar ada di admin/AdminSidebar.js.
const ITEMS = [
  { path: "/dashboardadmin", label: "Dashboard", icon: "bi-house" },
  { path: "/studentdatapage", label: "Student Data", icon: "bi-people", alsoActiveOn: ["/addstudent"] },
  { path: "/approvalpage", label: "Approval", icon: "bi-person-check" },
  { path: "/bannerpage", label: "Banner", icon: "bi-image" },
  { path: "/specialregpage", label: "Special Reg", icon: "bi-calendar-event" },
  { path: "/classschedulepage", label: "Class Schedule", icon: "bi-calendar3" },
  { path: "/scholarshipadminpage", label: "Scholarship", icon: "bi-mortarboard" },
  { path: "/installmentpage", label: "Installments", icon: "bi-credit-card" },
  { path: "/financialreport", label: "Financial Report", icon: "bi-cash-coin" },
  { path: "/studentpackage", label: "Student Package", icon: "bi-box-seam" },
  // Menu "Pending Payments" disembunyikan sementara atas permintaan admin.
  // Halaman + route (/pendingpayments) & endpoint backend tetap ada (dorman).
  // Untuk memunculkan lagi, aktifkan baris ini:
  // { path: "/pendingpayments", label: "Pending Payments", icon: "bi-hourglass-split" },
];

const SidebarAdmin = ({ isMobileAdmin }) => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axios.delete("/logoutAdmin");
    } catch (error) {
    } finally {
      navigate("/loginAdmin");
    }
  };

  return (
    <AdminSidebar
      items={ITEMS}
      variant="main"
      switchButton={{ label: "Switch to Attendance", path: "/attendance/dashboard" }}
      onLogout={logout}
      isMobileAdmin={isMobileAdmin}
    />
  );
};

export default SidebarAdmin;
